<template>
  <div class="dl_k">
    <div class="main">
      <div class="dl_nk">
        <div class="dl_nav">
          <a
            href="javascript:void(0)"
            :class="{ active: cur == 1 }"
            @click="cur = 1"
            >患者用户</a
          >
          <!--http://guanli.huaxiahelp.cn http://audit_guanli.huaxiahelp.cn/Admin/Home/Login-->
          <a href="http://audit_guanli.huaxiahelp.cn/Admin/Home/Login" target="_blank">管理用户</a>
        </div>
        <div class="dl_n">
          <el-form
            :model="lgForm_hz"
            :rules="rules"
            ref="lgForm_hz"
            class="lgform_hz"
          >
            <el-form-item label="手机号码：" prop="usermob">
              <el-input v-model="lgForm_hz.usermob"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" class="item_yzm" prop="uservcode">
              <el-input v-model="lgForm_hz.uservcode"></el-input>
              <div class="d_yzm">
                <img :src="codeImg" @click="changeCodeImg()" />
              </div>
            </el-form-item>
            <el-form-item
              label="短信验证码："
              class="item_yzm"
              prop="usermobvcode"
            >
              <el-input v-model="lgForm_hz.usermobvcode"></el-input>
              <div class="d_yzm">
                <el-button
                  type="info"
                  class="an_block"
                  :disabled="disabledBtn"
                  @click="sendCode"
                  >{{ text }}</el-button
                >
              </div>
            </el-form-item>
            <el-form-item class="lg_anq1">
              <el-button
                type="danger"
                class="an_r an_block"
                @click="submitForm('ruleForm')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
          <div class="lg_anq2">
            <span class="s_n">
              还没有帐号，<router-link to="/register" class="cd_r"
                >立即注册</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../http/http";
import api from "../http/api";
export default {
  data() {
    // 手机验证
    var validateMobilePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      text: "获取验证码",
      timer: 60,
      disabledBtn: false,
      time: null,
      codeImg: "",
      cur: 1,
      lgForm_hz: {
        usermob: "",
        uservcode: "",
        usermobvcode: "",
      },
      rules: {
        usermob: [
          { required: true, message: "请输入您的手机号码", trigger: "blur" },
          {
            validator: validateMobilePhone,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        uservcode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        usermobvcode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },

    };
  },
  mounted() {
    //初始图形验证码
    this.codeImg = this.GLOBAL.posturl + "api/account/validatecode";
  },
  methods: {
    // 获取倒计时
    getSecond(timer) {
      this.disabledBtn = true;
      this.text = this.timer + "s后重新获取";
      this.timer--;
      if (this.timer == 0) {
        clearInterval(this.time);
        this.text = "获取验证码";
        this.timer = 60;
        console.log(this.timer);
        this.disabledBtn = false;
      }
    },
    // 发送短信
    async sendCode() {
      let data = {
        MobilePhone: this.lgForm_hz.usermob,
        ValidateCode: this.lgForm_hz.uservcode,
      };
      if(data.MobilePhone.length>0 && data.ValidateCode.length>0){
        const res = await http.post(api.apismscode, data)
          if (res.data.Status == 1) {
            this.time = setInterval(() => {
              this.getSecond(60);
            }, 1000);
          }
          else {
            return this.$message.error(res.data.Message);
          };
      }

    },
    //表单验证
    submitForm(lgForm_hz) {
      this.$refs.lgForm_hz.validate((valid) => {
        if (valid) {
          let data = {
            MobilePhone: this.lgForm_hz.usermob,
            ValidateCode: this.lgForm_hz.usermobvcode,
          };

          http.post(api.apilogin, data).then(
            (res) => {
                //  console.log(res);
              if(res.data.Status==1) {
                  this.$store.commit('SET_TOKEN', res.data.obj.Token);
                  this.$store.commit('SET_RealName', res.data.obj.RealName);
                  this.$store.commit('SET_UserId', res.data.obj.UserId);
                  this.$message({message: '登陆成功', type: 'success'});
                   this.$router.push({path:'/user/userhome'});
               } else{
                 return this.$message.error(res.data.Message);
               }
            }, (error) => {
             console.log(err);
            }
          );


        } else {
          return false;
        }
      });
    },
    //刷新图形验证码
    changeCodeImg() {
      var num = Math.ceil(Math.random() * 10);
      this.codeImg = this.GLOBAL.posturl + "api/account/validatecode?num=" + num;
    },
    // open() {
    //   this.$alert("请直接与系统管理员联系，找回用户名或重置密码！", "提示", {
    //     confirmButtonText: "确定",
    //     confirmButtonClass: "an_r",
    //   });
    // },
  },
  created: function () {
    // this.$emit('header', false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue